import apiWithAuth from './apiWithAuth';

const agreementApi = {
  // Get the latest partner agreement
  getAgreement: async () => {
    try {
      const response = await apiWithAuth.get('/website-main/agreement/public');
      return { success: true, data: response.data };
    } catch (error) {
      if (error.response?.status === 404) {
        return { success: true, data: null };
      }
      return { success: false, error: error.response?.data?.error || 'Failed to load agreement' };
    }
  },

  // Create or update partner agreement
  saveAgreement: async (payload) => {
    try {
      const response = await apiWithAuth.put('/website-main/agreement/agreement', payload);
      return { success: true, data: response.data };
    } catch (error) {
      return { success: false, error: error.response?.data?.error || 'Failed to save agreement' };
    }
  },

  // Delete partner agreement
  deleteAgreement: async () => {
    try {
      await apiWithAuth.delete('/website-main/agreement/agreement');
      return { success: true };
    } catch (error) {
      return { success: false, error: error.response?.data?.error || 'Failed to delete agreement' };
    }
  },
};

export default agreementApi;
